const authUx = {
  en: {
    description: 'Build confidence with short, repeatable speaking practice — one sentence at a time.',
    intro: {
      login: 'Welcome back. Pick up where you left off.',
      signup: 'Create your account and start your first workout.',
      forgot: 'Enter your email to receive a password reset link.',
      reset: 'Choose a strong password for your account.',
      verify: 'Confirm your email to keep your account up to date.',
    },
    passwordGuidance: 'Use at least 8 characters, including a letter and a number.',
    showPassword: 'Show password', hidePassword: 'Hide password',
    showConfirmation: 'Show password confirmation', hideConfirmation: 'Hide password confirmation',
    changeLanguage: 'Change language', trainer: '{name} trainer logo',
    newHere: 'New here?', alreadyMember: 'Already have an account?',
    help: 'Account help',
  },
  ko: {
    description: '짧은 문장을 소리 내어 반복하며, 말하기에 자신감을 쌓아 보세요.',
    intro: {
      login: '다시 만나 반가워요. 지난 학습을 이어가 볼까요?',
      signup: '계정을 만들고 첫 훈련을 시작해 보세요.',
      forgot: '가입한 이메일로 비밀번호 재설정 링크를 보내드려요.',
      reset: '계정에 사용할 새 비밀번호를 입력해 주세요.',
      verify: '이메일 인증으로 계정 정보를 확인합니다.',
    },
    passwordGuidance: '영문자와 숫자를 포함해 8자 이상 입력해 주세요.',
    showPassword: '비밀번호 보기', hidePassword: '비밀번호 숨기기',
    showConfirmation: '확인 비밀번호 보기', hideConfirmation: '확인 비밀번호 숨기기',
    changeLanguage: '화면 언어 변경', trainer: '{name} 트레이너 로고',
    newHere: '처음 오셨나요?', alreadyMember: '이미 계정이 있나요?',
    help: '계정 도움말',
  },
};

export default authUx;
